import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-recipients-status-menu',
    imports: [CommonModule, OverlayModule, TranslateDirective, TranslatePipe],
    templateUrl: './recipients-status-menu.component.html',
    styleUrls: ['./recipients-status-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipientsStatusMenuComponent {
  @Output() changeStatusEvent = new EventEmitter()
  readonly positonAreaForSelectedDate = [{
    originX: 'end',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];

  isOpenMenu = false;

  changeStatus() { 
    this.changeStatusEvent.emit();
  }
}
